export default __webpack_public_path__ + "static/media/sort-amount-asc.34206cbf.svg";